import React from 'react';

export class CoordinatesTop extends React.Component {
  static chars = "ABCDEFGHJKLMNOPQRSTUVWXYZ"; // no I  

  render() {
    const texts = Array(this.props.boardSize).fill().map(
      (_, i) =>
        <svg 
          key={i} 
          className="coordinates"
          width={this.props.width}
          height={this.props.height}>
          <text
            className="coordinatesText"
            x="50%"
            y="51%"
            dominantBaseline="middle"
            textAnchor="middle">
            {CoordinatesTop.chars[i]}
          </text>
        </svg>);
    return texts;
  }
}

export class CoordinatesLeft extends React.Component {
  render() {
    const texts = Array(this.props.boardSize).fill().map(
      (_, i) =>
        <svg 
          key={i} 
          className="coordinates"
          width={this.props.width}
          height={this.props.height}>
          <text
            className="coordinatesText"
            x="50%"
            y="51%"
            dominantBaseline="middle"
            textAnchor="middle">
            {this.props.boardSize - i}
          </text>
        </svg>);
    return texts;
  }
}